import React from "react"
import "../../styles/components/BlockItem.scss"

export interface IBlockItem {
  src: string
  alt: string
  text: string
  classImg: string
  classPar: string
}

const BlockItem = ({ src, alt, text, classImg, classPar }: IBlockItem) => {
  return (
    <div className={"blockitem-block"}>
      <img className={classImg} src={src} alt={alt} />
      <p className={classPar}>{text}</p>
    </div>
  )
}

export default BlockItem
